import React from 'react';

import '../components/Surgery/SurgerySite.scss';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';
import { SurgeryMenu, SurgeryContent } from "../components";

class Surgery extends React.Component {
  constructor(props) {
    super();

    const stateSurgery = (props.location.state && props.location.state.surgeryId) ?
      props.location.state.surgeryId : 1;

    this.state = {
      surgeryActive: stateSurgery
    }
  }

  changeActiveTab = (e) => {
    this.setState({
      surgeryActive: parseInt(e.currentTarget.id)
    })
  };


  /** TOHLE SLOUŽÍ K VYTÁHNUTÍ SURGERIES PRO BACKEND **/
  getSurgeriesJson = () => {
      let surgery = this.props.texts.langs.surgery.map(surgery => {
          return {
              id: surgery.id,
              name: surgery.name,
              procedures: surgery.procedures
          }
      });


      surgery.forEach(sur => {
          let procedures = [];
          sur.procedures.forEach(proc => {
              procedures.push({
                  name: proc.name,
                  id: proc.id
              })
          });
          sur.procedures = procedures;
      });
  };

  render() {
    const langs = this.props.texts.langs;

    //this.getSurgeriesJson();
    return (
      <div>
        <div className="siteBanner newBg">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">Zákroky</h2>
        </div>

        <div className="surgerySite_wrap">
          <SurgeryMenu
            langs={{
              surgery: langs.surgery
            }}
            surgeryActive={this.state.surgeryActive}
            handleSurgeryClick={this.changeActiveTab}
          />
          <SurgeryContent
            langs={{
              surgery: langs.surgery.find(sur => sur.id === this.state.surgeryActive)
            }}
            surgeryActive={this.state.surgeryActive}
          />
        </div>

      </div>
    );
  }
}

export default Surgery;



// WEBPACK FOOTER //
// ./src/containers/Surgery.js